var React = require('react');

function Picture (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"13","r":"3","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M7 6H7.41421L7.70711 5.70711L9.12132 4.29289C9.30886 4.10536 9.56321 4 9.82843 4H14.1716C14.4368 4 14.6911 4.10536 14.8787 4.29289L16.2929 5.70711L16.5858 6H17H19C20.6569 6 22 7.34315 22 9V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V9C2 7.34315 3.34315 6 5 6H7Z","stroke":"currentColor","strokeWidth":"2","key":1})]);
}

Picture.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Picture;

Picture.default = Picture;
